import React from 'react'
import Menu from '../component/Menu';
import Aboutheader from '../component/Aboutheader'
import Body from '../component/Body'

const About = () => {
  return (
    <> 
      <Menu /> 
      <Aboutheader/>
      <Body/> 
    </>
  )
}

export default About